import type { IUserRef } from '@platform/core/types';

/** Значення для збереження з клітинки: особа → ідентифікатор, порожній рядок → null, решта — як є. */
export function inlineValue(value: unknown): unknown {
  if (value && typeof value === 'object' && !Array.isArray(value) && 'id' in (value as IUserRef)) return (value as IUserRef).id;
  return value === '' || value === undefined ? null : value;
}

/** Чи змінилося значення клітинки (порівняння після нормалізації; масиви тегів — поелементно). */
export function inlineChanged(next: unknown, prev: unknown): boolean {
  const a = inlineValue(next);
  const b = inlineValue(prev);
  if (Array.isArray(a) && Array.isArray(b)) return a.length !== b.length || a.some((x, i) => x !== b[i]);
  return a !== b;
}
